"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1695],{

/***/ 81695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_AemGridColumn; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./components/AemGrid.jsx
var AemGrid = __webpack_require__(99878);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/Shared/ContainerComponent.jsx




const ContainerComponent = (param)=>{
    let { children , extraProps , item , count  } = param;
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const timeOut = setTimeout(()=>{
            var ref;
            var ref1;
            const hashValue = (ref1 = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("#")[1]) !== null && ref1 !== void 0 ? ref1 : "";
            if (hashValue) {
                var ref2;
                var ref3;
                const element = (ref3 = document.querySelector("[id='".concat(hashValue, "']"))) !== null && ref3 !== void 0 ? ref3 : {};
                var ref4;
                const offsetTop = (ref4 = element === null || element === void 0 ? void 0 : (ref2 = element.parentNode) === null || ref2 === void 0 ? void 0 : ref2.offsetTop) !== null && ref4 !== void 0 ? ref4 : 0;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth"
                });
            }
        }, 1000);
        return ()=>{
            clearTimeout(timeOut);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-container".concat((extraProps === null || extraProps === void 0 ? void 0 : extraProps.fragment) === constants.FRAGMENT_TYPES.HEADER && (extraProps === null || extraProps === void 0 ? void 0 : extraProps.hasGlobalNavigation) && count === 0 ? " desk-header-height" : ""),
        id: item === null || item === void 0 ? void 0 : item.containerId,
        children: children
    });
};
/* harmony default export */ var Shared_ContainerComponent = (ContainerComponent);

;// CONCATENATED MODULE: ./components/AemGridColumn.jsx







const AemGridColumn = (props)=>{
    const { data , itemKey , count , eventHandler , containerId , configData ={} , ...extraProps } = props;
    const Element = modules["default"].Element;
    const scrollElementCondition = (item, key)=>{
        return (data === null || data === void 0 ? void 0 : data.columnClassNames) && (data === null || data === void 0 ? void 0 : data.columnClassNames[key]) && !(0,utils.isTeaser)(item) && !(0,utils.isBreadcrumb)(item) && !(0,utils.isCarousel)(item) && !(0,utils.isAemForm)(item) && !(0,utils.isProductAccordion)(item) && !(0,utils.isVideo)(item) && !(0,utils.isImage)(item) && !(0,utils.isInPageSearch)(item) && !(0,utils.isText)(item) && !(0,utils.isShopTheRoomCard)(item) && !(0,utils.isProductcardV3)(item);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
            const item = data[":items"][key];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils.ConditionalWrapper, {
                    condition: scrollElementCondition(item, key),
                    wrapper: (children)=>{
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Element, {
                            className: "".concat((0,utils.isImageV3)(item) ? "image-v3 image" : "").concat((0,utils.isContainer)(item) ? constants.staticClasses.CONTAINER : "").concat((item === null || item === void 0 ? void 0 : item.appliedCssClassNames) && ((0,utils.isContainer)(item) || (0,utils.isTab)(item)) ? " ".concat(item === null || item === void 0 ? void 0 : item.appliedCssClassNames) : "").concat((item === null || item === void 0 ? void 0 : item.appliedCssClassNamesCustom) ? " ".concat(item === null || item === void 0 ? void 0 : item.appliedCssClassNamesCustom) : "").concat((0,utils.isSlick)(item) ? "carousel-slick carousel ".concat((ref = item["carouselComponentProperties"]) === null || ref === void 0 ? void 0 : ref.appliedCssClassNames, " ") : "").concat((data === null || data === void 0 ? void 0 : data.columnClassNames[key]) ? !(0,utils.isSlick)(item) ? " ".concat(data === null || data === void 0 ? void 0 : data.columnClassNames[key], " ") : "" : "").concat((0,utils.isSpacer)(item) ? "spacer separator" : "", " ").concat((0,utils.isTab)(item) ? "tabs" : "").concat((0,utils.isList)(item) ? "list" : ""),
                            children: children
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils.ConditionalWrapper, {
                        condition: (0,utils.isContainer)(item) && key !== constants.COMPONENT_TYPES.ROOT_CONTAINER,
                        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_ContainerComponent, {
                                item: item,
                                extraProps: extraProps,
                                count: count,
                                children: children
                            }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid["default"], {
                            fullData: data[":items"] && data[":items"],
                            data: item,
                            itemKey: key ? key : itemKey,
                            count: count + 1,
                            containerId: (item === null || item === void 0 ? void 0 : item.containerId) || containerId,
                            eventHandler: eventHandler,
                            configData: configData,
                            ...extraProps
                        })
                    })
                })
            }, item.id ? item.id : index);
        })
    });
};
/* harmony default export */ var components_AemGridColumn = (AemGridColumn);


/***/ })

}]);